import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


const initialState = {};
export const fetchRange = createAsyncThunk("conflictThumbnail/fetchRange",
  async (payload, thunkAPI) => {
    try {
     
      const response = await axios.post("/customAPIs/get_range");

      const range = response.data;
      //console.log(range)

      return range;
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

const defaultCursorDetails = {
  searchDatabase: "Active",
  searchMode: "un-verified",
  project: "thailand-live",
  sd: "2023-03-02",
  ed: "2023-03-02",
  dataType: "",
  selectedType: "",
  selectedValue: "",
  currentKey: "",
  thumbnailDetails: [],
  lowerBound: 0,
  upperBound: 500,
  keys: [],
  endOfThumbnailList: false,
};
const conflictThumbnailSlice = createSlice({
  name: "conflictThumbnail",
  initialState: {
    cursorDetails2: defaultCursorDetails,
  },
  reducers: {
    updateThumbnailDetailsAndKey(state, action) {
      state.cursorDetails2.thumbnailDetails = action.payload.thumbnailDetails;
      state.cursorDetails2.currentKey = action.payload.currentKey;
    },
    markAsDiscarded(state, action) {
      state.cursorDetails2 = {
        ...state.cursorDetails2,
        thumbnailDetails: action.payload,
      };
    },
    updateDiscardedThumbnails(state, action) {
      const thumbnails = state.cursorDetails2.thumbnailDetails;
      const updatedThumbnails = thumbnails.filter((r) => r.discarded !== true);
      state.cursorDetails2.thumbnailDetails = updatedThumbnails;
    },
    resetCursorDetails(state, action) {
      state.cursorDetails2.dataType = "";
      state.cursorDetails2.selectedType = "";
      state.cursorDetails2.selectedValue = "";
      state.cursorDetails2.currentKey = "";
      state.cursorDetails2.thumbnailDetails = [];
      state.cursorDetails2.lowerBound = action.payload.lowerBound;
      state.cursorDetails2.upperBound = action.payload.upperBound;
      state.cursorDetails2.keys=[];
      state.cursorDetails2.endOfThumbnailList=false
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRange.pending, (state) => {
       //console.log("pending")
      })
      .addCase(fetchRange.fulfilled, (state, action) => {
        state.cursorDetails2.lowerBound = action.payload.lowerBound;
        state.cursorDetails2.upperBound = action.payload.upperBound;
        //console.log("fulfilled 1")
      })
      .addCase(fetchRange.rejected, (state, action) => {
      // console.log("rejected")
      });
  },
});

export const {
  updateThumbnailDetailsAndKey,
  markAsDiscarded,
  updateDiscardedThumbnails,
  resetCursorDetails
} = conflictThumbnailSlice.actions;

export default conflictThumbnailSlice.reducer;
